<template>
  <b-container class="main-container">
    <b-container v-if="!loading && !selectedSite">
      <SignIn v-if="sites && myUser" :sitesRaw="sites" :myUser="myUser"/>
    </b-container>
    <!-- <b-container v-else-if="currentAction !== 'signinmulti' && commonSignInComplete === false"> -->
    <b-container v-else-if="currentAction === null && commonSignInComplete === false">
      <div class="you-are-signed-in">
        <p>You are signed in to site:</p>
        <p class="site-name">{{(selectedSite || {}).jobNumber}} - {{(selectedSite || {}).siteName}}</p>
      </div>
      <div class="sign-out">
        <!-- TODO ensure when Signout happens for the login users they see the initial select site page  -->
        <vue-confirmation-button ref="deleteButton" :css="'btn btn-danger sm w-50'" :messages="['Sign Out','Yes, I am sure','Signing out...']" @confirmation-success="signOut((selectedSite || {}).site.id);"/>
      </div>
      <!-- <div v-if="foreperson !== myUserEmail" class="text-center"> -->
      <div v-if="foreperson === myUserEmail" class="text-center">
          <b-button @click="currentAction='signinmulti'; commonSignInComplete=false;" class="display-flex align-items-center justify-content-center visitor-sign-in-btn sign-in-btn sm w-50">
          <span class="mr-2">Sign In Visitor</span>
          <VisitorButtonIcon />
        </b-button>
      </div>
      <!-- <div v-if="foreperson === myUser.emailAddress || myUser.groups[0] === 'Administrators'" class="sign-out-visitor text-center"> -->
      <!-- <div v-if="foreperson !== myUserEmail" class="sign-out-visitor text-center"> -->
      <div v-if="foreperson === myUserEmail" class="sign-out-visitor text-center">
        <b-button @click="signOutPage(); commonSignInComplete=true;" class="display-flex align-items-center justify-content-center visitor-sign-in-btn sign-in-btn sm w-50">
          <span class="mr-2">Sign Out Visitor</span>
          <VisitorSignOutIcon />
        </b-button>
      </div>
      <div class="site-info signed-in">
        <div class="no-padding">
          <Site :boundSite="(selectedSite || {}).site"/>
        </div>
      </div>
    </b-container>
    <!--! Visitor Wizard steps  -->
    <b-container v-if="currentAction === 'signinmulti2' && commonSignInComplete === false">
      <b-row class="mt-4">
        <b-col class="pb-4">
          Please read the following site information and sign in.
        </b-col>
      </b-row>

      <b-row>
        <!-- <CommonSignIn :site="selectedSite.site" v-on:clear-site="clearSite" v-on:complete="completeCommonSignIn" /> -->
        <CommonSignIn :site="selectedSite.site" v-on:clear-site="clearSite" v-on:complete="publicResponse" />
      </b-row>
    </b-container>
    <!--! Public Enter details -->
    <!-- <b-container v-if="currentAction === 'signinmulti' && commonSignInComplete"> -->
    <b-container v-if="currentAction === 'signinmulti'">
      <b-col class="mt-4 mb-3 pl-0">
        Please Enter Details Below:
      </b-col>
      <!-- <b-form @submit="publicResponse" class="section-content-form"> -->
      <b-form class="section-content-form">
        Your name: <b-form-input v-model="responses.name" :state="(responses.name || '').length >= 5" required class="mb-3 mt-1" />
        Company: <b-form-input v-model="responses.company" :state="(responses.company || '').length >= 2" required class="mb-3 mt-1"/>
        Contact Mobile/Phone Number: <b-form-input v-model="responses.phoneNumber" :state="(responses.phoneNumber || '').length >= 7" required class="mb-3 mt-1"/>
        E-Mail Address: <b-form-input v-model="responses.emailAddress" :state="(responses.emailAddress || '').length >= 5" required class="mb-3 mt-1"/>
        Who are you visiting on site?: <b-form-input v-model="responses.visiting" :state="(responses.visiting || '').length >= 2" required class="mb-3 mt-1"/>
        <br/>
        <p class="pb-2">
        I agree to the conditions of this Hazard ID and consent that my name, location and contact details are recorded as part of the Schick site sign-in process.
        </p>
        <br/>
        <vue-recaptcha ref="recaptcha2" sitekey="6Lcd8fYUAAAAAB8pzpJhKcr6gNQLUqGG8WrjplYT" :loadRecaptchaScript="true" @verify="verifyRecaptcha"/>
          <b-row>
            <!-- <b-button v-on:click="publicResponse(); currentAction=null; commonSignInComplete=false" class="mt-3" variant="primary" :disabled="!recaptchaToken">Sign In</b-button> -->
            <!-- <b-button type="submit" value="Submit" class="mt-3" variant="primary" :disabled="!recaptchaToken">Add User</b-button> -->
          </b-row>
      </b-form>
      <!--! Back and Next Button -->
      <div id="next-btn-wrapper">
        <b-row ref="next" class="container section-alert-dark next-btn-container justify-content-between py-2 px-3">
          <b-button class="w-50 mr-1 ml-n1" variant="secondary" @click="backButton">
            <font-awesome-icon icon="arrow-circle-left" size="lg" fixedWidth class="icon" /> Back
          </b-button>
          <b-button class="w-50 ml-1 mr-n1" :disabled="isNextButtonDisabled" :variant="isNextButtonDisabled ? 'secondary' : 'success'"
            @click="currentAction='signinmulti2';commonSignInComplete=false">
            Next <font-awesome-icon icon="arrow-circle-right" size="lg" fixedWidth class="icon" />
          </b-button>
        </b-row>
      </div>
    </b-container>
    <!--! Visitor Sign outs -->
    <b-container v-if="currentAction === 'signoutmulti'">
      <div class="section-content-container mt-3">
        <b-row class="section-title justify-content-center">
          <b-row class="align-content-center">
            <h3 v-if="signIns.length > 0">Visitor Register: {{selectedSite.siteName}}</h3>
            <h3 v-else>No Visitors in {{selectedSite.siteName}}</h3>
          </b-row>
        </b-row>
      </div>
      <div>
        <!-- <b-col v-for="(signIn, index) in signIns" v-bind:key="index" class="section-content sign-in-register-content flex-column mt-3"> -->
        <b-col v-for="(signIn, index) in signIns" v-bind:key="index" class="section-content sign-in-register-content mt-3">
          <b-row class="align-items-center d-flex justify-content-between">
            <b-col class="container-size">
              <p class="name">{{signIn.name}}</p>
              <p>{{signIn.company}}</p>
            </b-col>
            <div>
              <p>{{signIn.phoneNumber}}</p>
            </div>
            <div>
            <!-- <vue-confirmation-button ref="deleteButton" :css="'btn btn-danger sm w-10 mt-3'" :messages="['Sign Out','Yes, I am sure','Signing out...']" @confirmation-success="publicSignOuts(index)"/> -->
              <b-button v-on:click="publicSignOuts(index)" class="btn btn-danger" variant="primary">Sign Out</b-button>
            </div>
          </b-row>
        </b-col>
          <!-- <p class="small">Signed in: {{signIn.signInTime | moment('timezone', 'Pacific/Auckland', 'h:mm A')}}</p>
          <p class="small">Signed out: <span v-if="signIn.signOutTime" >{{signIn.signOutTime | moment('timezone', 'Pacific/Auckland', 'h:mm A')}}</span></p> -->
          <!-- <vue-confirmation-button ref="deleteButton" :css="'btn btn-danger sm w-20'" :messages="['Sign Out','Yes, I am sure','Signing out...']" @confirmation-success="publicSignOuts(index)"/> -->
      </div>
      <div class="mt-5">
        <b-button v-on:click="backButton()" class="ml-3" variant="primary">Back</b-button>
      </div>
    </b-container>
  </b-container>
</template>

<style lang="scss">
  ul {
    padding-bottom: 0px;
    margin-bottom: 1px;
  }

  .sign-out .btn {
    margin: auto;
    display: block;
  }
  .sign-out-visitor {
    margin-top: 20px;
    display: block;
  }
  .sign-out .btn:after {
    content: url('../../public/sign-out-icon.svg');
    color: white;
    position: relative;
    top: 4px;
    left: 3px;
  }
  .container-size {
  flex-grow: 0.2 !important;
  }
</style>

<script>

import VueRecaptcha from 'vue-recaptcha';
import vueConfirmationButton from 'vue-confirmation-button';
import {
  getMyUser,
  signOut,
  getActiveSites,
  publicSignIn,
  publicSignOut,
  getSite,
  getPublicSignIns,
  // getSignIns,
} from '@/lib/api';
import { EventBus } from '@/lib/event-bus';
import moment from 'moment-timezone';
import Site from '@/components/Site.vue';
import SignIn from '@/components/SignIn.vue';
import VisitorButtonIcon from './VisitorButtonIcon.vue';
import VisitorSignOutIcon from './VisitorSignOutIcon.vue';
import CommonSignIn from './siteParts/CommonSignIn.vue';

export default {
  name: 'Home',
  props: {
    msg: String,
  },
  components: {
    Site,
    SignIn,
    vueConfirmationButton,
    VisitorButtonIcon,
    VisitorSignOutIcon,
    CommonSignIn,
    VueRecaptcha,
  },
  data() {
    return {
      myUser: null,
      loading: true,
      sites: [],
      tableFields: ['siteName', 'siteAddress', 'signInTime', 'signOutTime', 'signOut'],
      selectedSite: null,
      signedInto: [],
      currentAction: null,
      commonSignInComplete: false,
      responses: { covid19: {} },
      recaptchaToken: null,
      site: null,
      signIn: [],
      signIns: [],
      foreperson: null,
      myUserEmail: null,
      isAdmin: null,
    };
  },
  computed: {
    // ! New computed method
    isNextButtonDisabled() {
      return (
        !this.recaptchaToken
        || (this.responses.name ? this.responses.name.length < 5 : true)
        || (this.responses.company ? this.responses.company.length < 2 : true)
        || (this.responses.phoneNumber ? this.responses.phoneNumber.length < 7 : true)
        || (this.responses.emailAddress ? this.responses.emailAddress.length < 5 : true)
        || (this.responses.visiting ? this.responses.visiting.length < 2 : true)
      );
    },
    siteCount() {
      return this.myUser.todaysSignIns.filter((site) => !site.signOutTime).length;
    },
    keyedSites() {
      return this.sites.reduce((accumulator, site) => {
        /* eslint-disable no-param-reassign */
        accumulator[site.id] = site;
        return accumulator;
        /* eslint-enable no-param-reassign */
      }, {});
    },
  },
  async mounted() {
    EventBus.$emit('isCompact', false);
    await this.load();
    try {
      this.site = await getSite(this.selectedSite.siteId);
      this.foreperson = this.selectedSite.site.forepersonUsername;
      this.myUserEmail = this.myUser.emailAddress;
      this.myUser.groups[0] = this.isAdmin;
      console.log('Access Granted');
    } catch (error) {
      console.log('Access Denied');
    }
  },
  methods: {
    // Sign in Visitors
    async signInUpdate() {
      this.signIns = await getPublicSignIns(this.selectedSite.siteId, this.selectedSite.longid);
      this.signIns = this.signIns.filter((filteredSignIn) => filteredSignIn.signOutTime == null && filteredSignIn.visiting !== 'N/A - Internal Staff');
    },
    async signOutPage() {
      this.signInUpdate();
      this.currentAction = 'signoutmulti';
      window.scrollTo(0, 0);
    },
    backButton() {
      this.currentAction = null;
      this.commonSignInComplete = false;
      this.responses = {};
      this.recaptchaToken = null;
    },
    clearSite() {
      this.currentAction = 'signinmulti';
      this.recaptchaToken = null;
    },
    completeCommonSignIn(responses) {
      // this.commonSignInComplete = true;
      this.commonSignInComplete = false;
      this.responses = responses;
    },
    verifyRecaptcha(response) {
      this.recaptchaToken = response;
    },
    // do the actual sign in.
    async publicResponse() {
      // event.preventDefault();
      EventBus.$emit('showLoader');
      this.loading = true;
      // this.site = await getSite(this.selectedSite.siteId);
      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }
      await publicSignIn(this.site.id,
        this.site.longid,
        latLng,
        this.responses.name,
        this.responses.company,
        this.responses.emailAddress,
        this.responses.visiting,
        this.responses.phoneNumber,
        JSON.stringify(this.responses),
        this.recaptchaToken);
      // if (signInResponse.status === 409) {
      //   EventBus.$emit('triggerAlert', {
      //     type: 'success',
      //     message: 'Already signed in',
      //   });
      EventBus.$emit('triggerAlert', { type: 'success', message: 'Visitor has been signed in' });
      this.currentAction = null;
      this.commonSignInComplete = false;
      this.recaptchaToken = null;
      this.responses = {};
      this.signInUpdate();
      window.scrollTo(0, 0);
      this.loading = false;
      EventBus.$emit('hideLoader');
      // setTimeout(() => { window.location.reload(); }, 3000);
    },
    async publicSignOuts(arrayIndex) {
      EventBus.$emit('showLoader');
      this.loading = true;
      // this.site2 = await getSite(this.selectedSite.siteId);
      // get location
      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }
      await publicSignOut(
        this.site.id,
        this.site.longid,
        this.signIns[arrayIndex].longid,
        latLng,
        this.signIns[arrayIndex].name,
        this.signIns[arrayIndex].company,
        this.signIns[arrayIndex].emailAddress,
        this.signIns[arrayIndex].visiting,
        this.signIns[arrayIndex].phoneNumber,
      );
      this.signInUpdate();
      EventBus.$emit('triggerAlert', { type: 'success', message: 'Visitor has been signed out' });
      this.loading = false;
      EventBus.$emit('hideLoader');
    },
    // -------------------------------------------------------------------------------------------
    async load() {
      EventBus.$emit('showLoader');
      this.loading = true;

      // get myself and my site
      const results = await Promise.all([
        getMyUser(),
        getActiveSites(),
      ]);
      [this.myUser, this.sites] = results;

      // this should always be of length 1, but just in case....
      this.signedInto = this.myUser.todaysSignIns.filter((signIn) => !signIn.signOutTime).map((signIn) => {
        /* eslint-disable no-param-reassign */
        signIn.site = this.keyedSites[signIn.siteId];
        signIn.jobNumber = signIn.site.jobNumber;
        signIn.siteName = signIn.site.name;
        signIn.siteAddress = signIn.site.address;
        signIn.signInTime = moment(signIn.signInTime).tz('Pacific/Auckland').format('h:mm A');
        if (signIn.signOutTime) {
          signIn.signOutTime = moment(signIn.signOutTime).tz('Pacific/Auckland').format('h:mm A');
        }
        /* eslint-enable no-param-reassign */
        return signIn;
      });
      [this.selectedSite] = this.signedInto;

      this.loading = false;
      EventBus.$emit('hideLoader');
    },
    async signOut(siteId) {
      EventBus.$emit('showLoader');
      this.loading = true;
      this.selectedSite = null;
      let latLng;
      const currentLocation = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((position) => resolve(position), () => resolve(null)));
      if (currentLocation && currentLocation.coords) {
        latLng = `${currentLocation.coords.latitude}, ${currentLocation.coords.longitude}`;
      }
      await signOut(siteId, latLng);
      EventBus.$emit('triggerAlert', {
        type: 'success',
        message: 'Signed out',
      });
      this.currentAction = null;
      this.recaptchaToken = null;
      this.sites = [];
      this.selectedSite = null;
      await this.load();
      this.loading = false;
      EventBus.$emit('hideLoader');
    },
  },
};
</script>
